// @flow
import {closestIndex} from './closestIndex';

type Params = {|
    offset: number,
    offsetWidth: Array<number>,
    viewportWidth: number,
    overscanCellsRatio?: number,
|};

export const getCellEndIndex = ({offset, offsetWidth, viewportWidth, overscanCellsRatio}: Params): number => {
    const index = closestIndex(offset + viewportWidth * Number(overscanCellsRatio), offsetWidth) + 1;
    return index === offsetWidth.length - 1 ? offsetWidth.length : index;
};
